import { createClient } from '@supabase/supabase-js';

// Usar directamente las credenciales de Supabase
// IMPORTANTE: Actualiza estas credenciales desde el panel de Supabase
const supabaseUrl = 'https://jlufgkgssnxumguvknhc.supabase.co';
// Clave API anónima actualizada
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImpsdWZna2dzc254dW1ndXZrbmhjIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDAzMzExNDgsImV4cCI6MjA1NTkwNzE0OH0.zN1dff6EGgtjMMLkdXwS3idfAcg7FD741oKEeWI6ejg';

console.log('Inicializando cliente Supabase con URL:', supabaseUrl);

export const supabase = createClient(supabaseUrl, supabaseKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
  },
  db: {
    schema: 'public'
  }
});

// Comprobar si está correctamente configurada la conexión con Supabase
